import { useEffect } from 'react';

/**
 * Sets CSS variable --vh to 1% of the current viewport height (window.innerHeight).
 * Use with fallback for height/minHeight: calc(var(--vh, 1vh) * 100) when 100dvh is not supported.
 * Updates on resize, orientationchange, and visualViewport resize so the fixed bottom bar
 * stays visible when the browser UI (address bar, bottom nav) expands/collapses.
 * Safe to call from App.js so it runs on all pages.
 */
function setVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function useViewportHeight() {
  useEffect(() => {
    setVh();

    const handleResize = () => setVh();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Fires when browser chrome (address bar, bottom bar) shows/hides
    const viewport = window.visualViewport;
    if (viewport) {
      viewport.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
        viewport.removeEventListener('resize', handleResize);
      };
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);
}
